import React, {useEffect, useState} from 'react';
import './DocumentIssuance.scss';
import GetInitialData from "./GetInitialData";
import Loader from "../../../Loader";
import RowDocumentCode from "./TopTable/RowDocumentCode";
import TableDocumentIssuance from "./TableSide/TableDocumentIssuance";
import DetailDocumentIssuance from "./BottomTable/DetailDocumentIssuance";
import RowSubmitDocumentIssuance from "./BottomTable/RowSubmitDocumentIssuance";
import {useLocation} from "react-router-dom";

const DocumentIssuance = () => {
  // submitDocumentForm
  const myLocation = useLocation();
  const [initialData, setInitialData] = useState({
    pageData: {},
    groups: []
  });
  const [isLoad, setIsLoad] = useState(false);
  const [sendData, setSendData] = useState({
    mode: "add",
    documentCode: "",
    documentDescription: "",
    documentDate: "",
    documentTime: "",
    documentDetails: [
      {
        uniqId: Math.random() * 13,
        accountCode_3: "",
        accountCode_4: "",
        description: "",
        hasSubAccount: false,
        bed: "0",
        bes: "0"
      },
    ]
  });

  useEffect(() => {
    void GetInitialData(setInitialData, setIsLoad, sendData, setSendData, myLocation?.state?.id, myLocation?.state?.copyPkValue)
  }, []);

  return (
    <section className={"main-document-issuance"}>
      {isLoad ?
        <>
          <RowDocumentCode initialData={initialData} sendData={sendData} setSendData={setSendData}/>
          <TableDocumentIssuance initialData={initialData} sendData={sendData} setSendData={setSendData}/>
          <DetailDocumentIssuance sendData={sendData} setSendData={setSendData}/>
          <RowSubmitDocumentIssuance sendData={sendData} setSendData={setSendData}/>
        </> : <Loader/>}
    </section>
  );
};

export default React.memo(DocumentIssuance);